import React, { memo } from "react";

import { ShowcaseIntro } from "ui/components/Showcase";

import {
  OFFICE_ADDRESS_STEP,
  OFFICE_EMAIL_STEP,
  OFFICE_INFO_STEP,
  OFFICE_INFO_TEXTS,
  OFFICE_INTRO_SAMPLE,
  OFFICE_INTRO_TEXTS,
  OFFICE_NOTE_STEP,
  OFFICE_PHONE_STEP,
  OFFICE_SUMMARY_STEP,
  OFFICE_USER_STEP,
} from "./consts";
import OfficeAddressScene from "./scenes/OfficeAddressScene";
import OfficeEmailScene from "./scenes/OfficeEmailScene";
import OfficeInfoScene from "./scenes/OfficeInfoScene";
import OfficeNoteScene from "./scenes/OfficeNoteScene";
import OfficePhoneScene from "./scenes/OfficePhoneScene";
import OfficeSummaryScene from "./scenes/OfficeSummaryScene";
import OfficeUserScene from "./scenes/OfficeUserScene";
import { OfficeIntroProps, OfficeSceneProps } from "./types";

/** Scena za korak čarobnjaka poslovnice. */
const STEP_SCENES: Record<number, React.FC<OfficeSceneProps>> = {
  [OFFICE_INFO_STEP]: OfficeInfoScene,
  [OFFICE_ADDRESS_STEP]: OfficeAddressScene,
  [OFFICE_EMAIL_STEP]: OfficeEmailScene,
  [OFFICE_PHONE_STEP]: OfficePhoneScene,
  [OFFICE_USER_STEP]: OfficeUserScene,
  [OFFICE_NOTE_STEP]: OfficeNoteScene,
  [OFFICE_SUMMARY_STEP]: OfficeSummaryScene,
};

/** Lijevi panel unosa poslovnice: za svaki korak vlastita scena, a ispod objašnjenje koraka. */
const OfficeIntro: React.FC<OfficeIntroProps> = ({ formValues, isEdit, stepCurrent, stepCount }) => {
  const stepKey = STEP_SCENES[stepCurrent] ? stepCurrent : OFFICE_INFO_STEP;
  const Scene = STEP_SCENES[stepKey];
  const infoText = isEdit ? OFFICE_INFO_TEXTS.edit : OFFICE_INFO_TEXTS.create;
  const text = stepKey === OFFICE_INFO_STEP ? infoText : OFFICE_INTRO_TEXTS[stepKey];

  return (
    <ShowcaseIntro
      sceneKey={stepKey}
      title={text.title}
      description={text.description}
      stepCurrent={stepKey}
      stepCount={stepCount}
    >
      <Scene formValues={formValues} name={formValues.name || OFFICE_INTRO_SAMPLE.name} />
    </ShowcaseIntro>
  );
};

export default memo(OfficeIntro);
